// AUTO-GENERATED by generate-routes.cjs - DO NOT EDIT
import React, { Suspense } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { GlobalContextProviders } from "./components/_globalContextProviders";

import L__ from "./pages/$.pageLayout";
import L__con from "./pages/_con.pageLayout";
import L__index from "./pages/_index.pageLayout";
import L_account_recovery from "./pages/account-recovery.pageLayout";
import L_admin_organizations from "./pages/admin.organizations.pageLayout";
import L_admin_settings from "./pages/admin.settings.pageLayout";
import L_admin_users from "./pages/admin.users.pageLayout";
import L_dashboard_notifications from "./pages/dashboard.notifications.pageLayout";
import L_dashboard from "./pages/dashboard.pageLayout";
import L_delete_account from "./pages/delete-account.pageLayout";
import L_expenses from "./pages/expenses.pageLayout";
import L_forgot_password from "./pages/forgot-password.pageLayout";
import L_import from "./pages/import.pageLayout";
import L_isl from "./pages/isl.pageLayout";
import L_leases from "./pages/leases.pageLayout";
import L_login from "./pages/login.pageLayout";
import L_maintenance from "./pages/maintenance.pageLayout";
import L_onboarding from "./pages/onboarding.pageLayout";
import L_payments from "./pages/payments.pageLayout";
import L_privacy from "./pages/privacy.pageLayout";
import L_profile_settings from "./pages/profile.settings.pageLayout";
import L_properties__propertyId from "./pages/properties.$propertyId.pageLayout";
import L_properties from "./pages/properties.pageLayout";
import L_purchase_orders from "./pages/purchase-orders.pageLayout";
import L_register from "./pages/register.pageLayout";
import L_reports from "./pages/reports.pageLayout";
import L_reset_password from "./pages/reset-password.pageLayout";
import L_settings from "./pages/settings.pageLayout";
import L_suppliers from "./pages/suppliers.pageLayout";
import L_tenant_portal_dashboard from "./pages/tenant-portal.dashboard.pageLayout";
import L_tenant_portal_documents from "./pages/tenant-portal.documents.pageLayout";
import L_tenant_portal_lease from "./pages/tenant-portal.lease.pageLayout";
import L_tenant_portal_maintenance from "./pages/tenant-portal.maintenance.pageLayout";
import L_tenant_portal_notifications from "./pages/tenant-portal.notifications.pageLayout";
import L_tenant_portal_payments from "./pages/tenant-portal.payments.pageLayout";
import L_tenant_portal_profiles from "./pages/tenant-portal.profiles.pageLayout";
import L_tenant_portal_setup from "./pages/tenant-portal.setup.pageLayout";
import L_tenant_portal from "./pages/tenant-portal.pageLayout";
import L_tenants__tenantId from "./pages/tenants.$tenantId.pageLayout";
import L_tenants from "./pages/tenants.pageLayout";
import L_terms from "./pages/terms.pageLayout";
import L_user_guide from "./pages/user-guide.pageLayout";

const P__ = React.lazy(() => import("./pages/$"));
const P__con = React.lazy(() => import("./pages/_con"));
const P__index = React.lazy(() => import("./pages/_index"));
const P_account_recovery = React.lazy(() => import("./pages/account-recovery"));
const P_admin_organizations = React.lazy(() => import("./pages/admin.organizations"));
const P_admin_settings = React.lazy(() => import("./pages/admin.settings"));
const P_admin_users = React.lazy(() => import("./pages/admin.users"));
const P_dashboard_notifications = React.lazy(() => import("./pages/dashboard.notifications"));
const P_dashboard = React.lazy(() => import("./pages/dashboard"));
const P_delete_account = React.lazy(() => import("./pages/delete-account"));
const P_expenses = React.lazy(() => import("./pages/expenses"));
const P_forgot_password = React.lazy(() => import("./pages/forgot-password"));
const P_import = React.lazy(() => import("./pages/import"));
const P_isl = React.lazy(() => import("./pages/isl"));
const P_leases = React.lazy(() => import("./pages/leases"));
const P_login = React.lazy(() => import("./pages/login"));
const P_maintenance = React.lazy(() => import("./pages/maintenance"));
const P_onboarding = React.lazy(() => import("./pages/onboarding"));
const P_payments = React.lazy(() => import("./pages/payments"));
const P_privacy = React.lazy(() => import("./pages/privacy"));
const P_profile_settings = React.lazy(() => import("./pages/profile.settings"));
const P_properties__propertyId = React.lazy(() => import("./pages/properties.$propertyId"));
const P_properties = React.lazy(() => import("./pages/properties"));
const P_purchase_orders = React.lazy(() => import("./pages/purchase-orders"));
const P_register = React.lazy(() => import("./pages/register"));
const P_reports = React.lazy(() => import("./pages/reports"));
const P_reset_password = React.lazy(() => import("./pages/reset-password"));
const P_settings = React.lazy(() => import("./pages/settings"));
const P_suppliers = React.lazy(() => import("./pages/suppliers"));
const P_tenant_portal_dashboard = React.lazy(() => import("./pages/tenant-portal.dashboard"));
const P_tenant_portal_documents = React.lazy(() => import("./pages/tenant-portal.documents"));
const P_tenant_portal_lease = React.lazy(() => import("./pages/tenant-portal.lease"));
const P_tenant_portal_maintenance = React.lazy(() => import("./pages/tenant-portal.maintenance"));
const P_tenant_portal_notifications = React.lazy(() => import("./pages/tenant-portal.notifications"));
const P_tenant_portal_payments = React.lazy(() => import("./pages/tenant-portal.payments"));
const P_tenant_portal_profiles = React.lazy(() => import("./pages/tenant-portal.profiles"));
const P_tenant_portal_setup = React.lazy(() => import("./pages/tenant-portal.setup"));
const P_tenant_portal = React.lazy(() => import("./pages/tenant-portal"));
const P_tenants__tenantId = React.lazy(() => import("./pages/tenants.$tenantId"));
const P_tenants = React.lazy(() => import("./pages/tenants"));
const P_terms = React.lazy(() => import("./pages/terms"));
const P_user_guide = React.lazy(() => import("./pages/user-guide"));

function Wrap({ layouts, children }: { layouts?: React.ComponentType<any>[], children: React.ReactNode }) {
  if (!layouts) return <>{children}</>;
  let el = children;
  for (let i = layouts.length - 1; i >= 0; i--) { const C = layouts[i]; el = <C>{el}</C>; }
  return <>{el}</>;
}

export default function App() {
  return (
    <BrowserRouter>
      <GlobalContextProviders>
        <Suspense fallback={<div style={{display:"flex",justifyContent:"center",alignItems:"center",height:"100vh"}}>Loading...</div>}>
          <Routes>
            <Route path="/$" element={<Wrap layouts={L__}><P__ /></Wrap>} />
            <Route path="/con" element={<Wrap layouts={L__con}><P__con /></Wrap>} />
            <Route path="/" element={<Wrap layouts={L__index}><P__index /></Wrap>} />
            <Route path="/account-recovery" element={<Wrap layouts={L_account_recovery}><P_account_recovery /></Wrap>} />
            <Route path="/admin/organizations" element={<Wrap layouts={L_admin_organizations}><P_admin_organizations /></Wrap>} />
            <Route path="/admin/settings" element={<Wrap layouts={L_admin_settings}><P_admin_settings /></Wrap>} />
            <Route path="/admin/users" element={<Wrap layouts={L_admin_users}><P_admin_users /></Wrap>} />
            <Route path="/dashboard/notifications" element={<Wrap layouts={L_dashboard_notifications}><P_dashboard_notifications /></Wrap>} />
            <Route path="/dashboard" element={<Wrap layouts={L_dashboard}><P_dashboard /></Wrap>} />
            <Route path="/delete-account" element={<Wrap layouts={L_delete_account}><P_delete_account /></Wrap>} />
            <Route path="/expenses" element={<Wrap layouts={L_expenses}><P_expenses /></Wrap>} />
            <Route path="/forgot-password" element={<Wrap layouts={L_forgot_password}><P_forgot_password /></Wrap>} />
            <Route path="/import" element={<Wrap layouts={L_import}><P_import /></Wrap>} />
            <Route path="/isl" element={<Wrap layouts={L_isl}><P_isl /></Wrap>} />
            <Route path="/leases" element={<Wrap layouts={L_leases}><P_leases /></Wrap>} />
            <Route path="/login" element={<Wrap layouts={L_login}><P_login /></Wrap>} />
            <Route path="/maintenance" element={<Wrap layouts={L_maintenance}><P_maintenance /></Wrap>} />
            <Route path="/onboarding" element={<Wrap layouts={L_onboarding}><P_onboarding /></Wrap>} />
            <Route path="/payments" element={<Wrap layouts={L_payments}><P_payments /></Wrap>} />
            <Route path="/privacy" element={<Wrap layouts={L_privacy}><P_privacy /></Wrap>} />
            <Route path="/profile/settings" element={<Wrap layouts={L_profile_settings}><P_profile_settings /></Wrap>} />
            <Route path="/properties/:propertyId" element={<Wrap layouts={L_properties__propertyId}><P_properties__propertyId /></Wrap>} />
            <Route path="/properties" element={<Wrap layouts={L_properties}><P_properties /></Wrap>} />
            <Route path="/purchase-orders" element={<Wrap layouts={L_purchase_orders}><P_purchase_orders /></Wrap>} />
            <Route path="/register" element={<Wrap layouts={L_register}><P_register /></Wrap>} />
            <Route path="/reports" element={<Wrap layouts={L_reports}><P_reports /></Wrap>} />
            <Route path="/reset-password" element={<Wrap layouts={L_reset_password}><P_reset_password /></Wrap>} />
            <Route path="/settings" element={<Wrap layouts={L_settings}><P_settings /></Wrap>} />
            <Route path="/suppliers" element={<Wrap layouts={L_suppliers}><P_suppliers /></Wrap>} />
            <Route path="/tenant-portal/dashboard" element={<Wrap layouts={L_tenant_portal_dashboard}><P_tenant_portal_dashboard /></Wrap>} />
            <Route path="/tenant-portal/documents" element={<Wrap layouts={L_tenant_portal_documents}><P_tenant_portal_documents /></Wrap>} />
            <Route path="/tenant-portal/lease" element={<Wrap layouts={L_tenant_portal_lease}><P_tenant_portal_lease /></Wrap>} />
            <Route path="/tenant-portal/maintenance" element={<Wrap layouts={L_tenant_portal_maintenance}><P_tenant_portal_maintenance /></Wrap>} />
            <Route path="/tenant-portal/notifications" element={<Wrap layouts={L_tenant_portal_notifications}><P_tenant_portal_notifications /></Wrap>} />
            <Route path="/tenant-portal/payments" element={<Wrap layouts={L_tenant_portal_payments}><P_tenant_portal_payments /></Wrap>} />
            <Route path="/tenant-portal/profiles" element={<Wrap layouts={L_tenant_portal_profiles}><P_tenant_portal_profiles /></Wrap>} />
            <Route path="/tenant-portal/setup" element={<Wrap layouts={L_tenant_portal_setup}><P_tenant_portal_setup /></Wrap>} />
            <Route path="/tenant-portal" element={<Wrap layouts={L_tenant_portal}><P_tenant_portal /></Wrap>} />
            <Route path="/tenants/:tenantId" element={<Wrap layouts={L_tenants__tenantId}><P_tenants__tenantId /></Wrap>} />
            <Route path="/tenants" element={<Wrap layouts={L_tenants}><P_tenants /></Wrap>} />
            <Route path="/terms" element={<Wrap layouts={L_terms}><P_terms /></Wrap>} />
            <Route path="/user-guide" element={<Wrap layouts={L_user_guide}><P_user_guide /></Wrap>} />
          </Routes>
        </Suspense>
      </GlobalContextProviders>
    </BrowserRouter>
  );
}
